const axios = require('axios');
const { baseUrlNew, buildAuthHeaders } = require('./settings.js');

// Fetch all tags for the company
const fetchTagList = function () {
  return axios.get(baseUrlNew + 'tag/', {
    headers: buildAuthHeaders()
  });
};

module.exports = {
  fetchTagList
};
